import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { createElement, FC } from 'react';
import { useRecoilValue } from 'recoil';

import ProjectEditingStep from '../../../../entity/ProjectEditingStep';
import theme from '../../../../theme';
import { convertStepToOrder } from '../../../../utility/workflowStepConvert';
import WorkflowStepper from '../../../component/compound/WorkflowStepper';
import { SPACING_REGULAR } from '../../../constant/spacing';
import { workflowStepsAtom } from '../atoms/workflowStepsAtom';

type Props = {
  step: ProjectEditingStep;
  updateDraftAndGoToTargetStep: (targetStep: ProjectEditingStep) => void;
};

const LeftWorkflowStepper: FC<Props> = ({ step, updateDraftAndGoToTargetStep }) => {
  const workflowSteps = useRecoilValue(workflowStepsAtom);

  const handleClickStep = (targetStep: ProjectEditingStep) => {
    const targetStepNumber = convertStepToOrder(targetStep, workflowSteps);
    const currentStepNumber = step ? convertStepToOrder(step, workflowSteps) : 0;
    if (currentStepNumber > targetStepNumber) {
      updateDraftAndGoToTargetStep(targetStep);
    }
  };

  return (
    <SideGrid item xs={12} sm={12} md={12} lg={3}>
      <LeftStepper>
        <WorkflowStepper
          currentStep={step || 'format'}
          handleClickStep={handleClickStep}
          workflowSteps={workflowSteps}
        />
      </LeftStepper>
    </SideGrid>
  );
};

const SideGrid = styled(Grid)`
  position: relative;
`;

const LeftStepper = styled.div`
  position: sticky;
  top: ${SPACING_REGULAR}px;

  ${theme.breakpoints.down('sm')} {
    position: static;
  }
`;

export default LeftWorkflowStepper;
